<!-- 补贴-填写信息 -->
<template>
  <div>
    <van-steps active-color="#1989FA" :active="0">
      <van-step>填写信息</van-step>
      <van-step>上传资料</van-step>
      <van-step>资格审核</van-step>
      <van-step>办理手续</van-step>
    </van-steps>
    <div class="list-title">填写基本信息</div>
    <van-field
      v-model="formData.company_name"
      label="企业名称"
      placeholder="请填写企业名称"
      @input="saveCache()"
    />
    <!-- <div class="list-item-title">统一社会信用代码</div>
    <van-field
      v-model="formData.uscc"
      placeholder="请填写统一社会信用代码"
      @input="saveCache()"
    />-->
    <sh-picker-field
      v-model="formData.company_registration"
      title="企业注册地"
      :text-data="COMPANY_REGISTRATION_TEXT"
      :columns="COMPANY_REGISTRATION_SELECTS.map((item) => item.label)"
      @input="saveCache()"
    ></sh-picker-field>
    <!-- <van-field
      v-model="formData.corp"
      label="法人"
      placeholder="请填写法人姓名"
      @input="saveCache()"
    />-->
    <!-- 广州4050社保补贴 -->
    <template v-if="type === APPLY_TYPE.GZ4050SBBT">
      <!-- <van-field
        v-model="formData.name"
        label="申请人姓名"
        placeholder="请填写申请人姓名"
        @input="saveCache()"
      />
      <van-field
        v-model="formData.contact"
        label="申请人电话"
        placeholder="请填写申请人电话"
        @input="saveCache()"
      />-->
    </template>
    <!-- 适岗培训补贴 || 失业保险稳岗补贴 -->
    <template v-else>
      <van-field
        v-model="formData.name"
        label="联系人姓名"
        placeholder="请填写联系人姓名"
        @input="saveCache()"
      />
      <van-field
        v-model="formData.contact"
        label="联系方式"
        placeholder="请填写联系方式"
        @input="saveCache()"
      />
      <van-field
        v-model="formData.contacts_title"
        label="联系人职务"
        placeholder="请填写联系人职务"
        @input="saveCache()"
      />
      <template v-if="type === APPLY_TYPE.SGPXBT">
        <van-field
          v-model="formData.attnos"
          label="参训人员总数"
          placeholder="请填写参训人员总数"
          @input="saveCache()"
        />
        <van-field
          v-model="formData.datp"
          label="申报参训岗位"
          placeholder="请填写申报参训岗位"
          @input="saveCache()"
        />
      </template>
      <template v-if="type === APPLY_TYPE.SYBXWGBT">
        <van-field
          v-model="formData.eitnos"
          label="企业参保人员总数"
          placeholder="请填写企业参保人员总数"
          @input="saveCache()"
        />
        <div class="list-item-title">企业是否依法在本市参加失业保险并足额缴纳失业保险费一年以上</div>
        <van-radio-group
          v-model="formData.epui"
          class="p-40 flex"
          direction="horizontal"
          @change="saveCache()"
        >
          <van-radio class="flex1" :name="1">
            是
          </van-radio>
          <van-radio class="flex1" :name="2">
            否
          </van-radio>
        </van-radio-group>
      </template>
    </template>
    <!--    <template v-if="type === APPLY_TYPE.GZ4050SBBT">
          <div class="list-item-title">申报对象户口性质</div>
          <sh-picker-field
            v-model="formData.account_properties"
            picker-title="户口性质"
            :text-data="ACCOUNT_PROPERTIES_TEXT"
            :columns="ACCOUNT_PROPERTIES_SELECTS.map((item) => item.label)"
            @input="saveCache()"
          ></sh-picker-field>
        </template>-->
    <CFooter></CFooter>

    <div class="height-180"></div>
    <div class="fixed-bottom border-box p-40">
      <van-button block round type="info" @click="handleToNext">
        下一步
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  APPLY_TYPE,
  COMPANY_REGISTRATION_TEXT,
  COMPANY_REGISTRATION_SELECTS,
  ACCOUNT_PROPERTIES_TEXT,
  ACCOUNT_PROPERTIES_SELECTS,
} from "@share/enum"
import CFooter from "@/components/CFooter.vue"
import { Toast } from "vant"
import shPickerField from "@/components/sh-picker-field.vue"

export default {
  name: "SubsidyInfo",
  components: {
    CFooter,
    "sh-picker-field": shPickerField,
  },
  data: () => {
    return {
      APPLY_TYPE,
      COMPANY_REGISTRATION_TEXT,
      COMPANY_REGISTRATION_SELECTS,
      ACCOUNT_PROPERTIES_TEXT,
      ACCOUNT_PROPERTIES_SELECTS,
      type: undefined,
      formData: null,
    }
  },
  computed: {},
  created() {
    this.type = Number(this.$route.params.type)
    this.formData = JSON.parse(sessionStorage.getItem("SUBSIDY_STEP_1") || null)
    if (!this.formData) {
      this.formData = {
        company_name: "", // 企业名称
        // uscc: "", // 统一社会信用代码
        company_registration: "", // 企业注册地
        name: "", // 姓名
        contact: "", // 联系方式
        // corp: "", // 法人
        // corp_telphone: "", // 法人电话
        account_properties: "", // 申报对象户口性质
        contacts_title: "", // 联系人职务
        attnos: "", // 参训人员总数（适岗培训补贴）
        datp: "", // 申报参训岗位（适岗培训补贴）
        eitnos: "", // 企业参保人员总数（失业保险稳岗补贴）
        epui: 2, // 企业是否依法在本市参加失业保险并足额缴纳失业保险费一年以上（失业保险稳岗补贴）
      }
    }
    // sessionStorage.removeItem("SUBSIDY_STEP_1")
  },
  mounted() {},
  methods: {
    saveCache() {
      sessionStorage.setItem("SUBSIDY_STEP_1", JSON.stringify(this.formData))
    },
    /** 下一步 */
    handleToNext() {
      if (!this.checkSubmit()) return
      this.saveCache()
      this.$router.push({
        path: `/apply/upload/${this.type}`,
      })
    },
    /** 校验提交 */
    checkSubmit() {
      if (
        !this.formData.company_name ||
        this.formData.company_name.length < 5
      ) {
        Toast("企业名称最少为5个字符")
        return false
      }
      // if (this.formData.uscc.length !== 18) {
      //   Toast("统一社会信用代码必须是18个字符")
      //   return false
      // }
      if (!this.formData.company_registration) {
        Toast("请选择企业注册地")
        return false
      }
      if (this.formData.name < 2 || this.formData.name.length > 12) {
        Toast("姓名必须是2~12个字符")
        return false
      }
      if (
        this.formData.contact.length < 7 ||
        this.formData.contact.length > 12
      ) {
        Toast("联系电话必须是7~12位数字")
        return false
      }
      // if (this.formData.corp < 2 || this.formData.corp.length > 12) {
      //   Toast("法人姓名必须是2~12个字符")
      //   return false
      // }
      /* if (this.formData.corp_telphone.length < 7 || this.formData.corp_telphone.lenfth > 12) {
       Toast("法人电话号码必须是7~12位数字")
       return false
       } */
      // if (
      //   this.type === APPLY_TYPE.GZ4050SBBT &&
      //   !this.formData.account_properties
      // ) {
      //   Toast("请选择户口性质")
      //   return false
      // }
      if (!this.formData.contacts_title) {
        Toast("请填写联系人职务")
        return false
      }
      if (this.type === APPLY_TYPE.SGPXBT) {
        if (!this.formData.attnos) {
          Toast("请填写参训人员总数")
          return false
        }
        if (!this.formData.datp) {
          Toast("请填写申报参训岗位")
          return false
        }
      }
      if (this.type === APPLY_TYPE.SYBXWGBT) {
        if (!this.formData.eitnos) {
          Toast("请填写企业参保人员总数")
          return false
        }
        if (!this.formData.epui) {
          Toast("请选择企业是否依法在本市参加失业保险并足额缴纳失业保险费一年以上")
          return false
        }
      }
      return true
    },
  },
}
</script>

<style lang="scss" scope>
@import "~@/assets/style/app";
</style>
